import { useState, useEffect } from "react";
import img from "../Assets/bg.jpg";

const Secrets = () => {
    const style = {
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: -2,
        backgroundImage: `url(${img})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
    };

    const [active, setActive] = useState(false);
    const [k, setK] = useState([]);
    const p = "38,38,40,40,37,39,37,39,66,65".split(",");

    useEffect(() => {
        const h = (e) => {
            const c = String(e.keyCode);
            const s = [...k, c];

            if (s.length > p.length) {
                s.shift();
            }

            setK(s);

            if (s.length === p.length && s.every((v, i) => v === p[i])) {
                setActive(!active);
            }
        };

        window.addEventListener("keydown", h);
        return () => window.removeEventListener("keydown", h);
    }, [k]);

    return active ? <div style={style}>Secrets</div> : <></>;
};

export default Secrets;
